import {analyticsLogger} from 'analytics/analyticsLogger';

/**
 * Where a metric status change originated. Lets us distinguish the inline status
 * dropdowns (annual list vs quarterly table) from the batched edit modal save.
 */
export type WorkstreamMetricStatusChangeSource =
  | 'details_inline_annual'
  | 'details_inline_quarterly'
  | 'edit_modal';

export function logWorkstreamMetricStatusChanged(
  source: WorkstreamMetricStatusChangeSource,
  data: {
    workstream_id: number;
    metric_id: number;
    status: string;
    previous_status?: string;
  }
) {
  analyticsLogger().logEvent('WORKSTREAM_METRIC_STATUS_CHANGED', {
    source,
    ...data,
  });
}

/**
 * Which Metrics surface an interaction came from: the workstream details page vs.
 * the /workstreams list/pillar scorecard.
 */
export type WorkstreamMetricsViewSource = 'details' | 'workstreams_scorecard';

export function logWorkstreamMetricsSubworkstreamsExpanded(
  source: WorkstreamMetricsViewSource,
  data: {
    workstream_id: number;
    expanded: boolean;
    sub_workstream_count: number;
  }
) {
  analyticsLogger().logEvent('WORKSTREAM_METRICS_SUBWORKSTREAMS_EXPANDED', {
    source,
    ...data,
  });
}

/**
 * A change to the Metrics view's timeframe controls: the Annual/Quarterly grain
 * toggle (`change_type: 'grain'`) or the quarter/year dropdown selection
 * (`change_type: 'timeframe'`). Fired only on user-initiated changes. `grain`,
 * `quarter` (quarterly only), and `year` reflect the resulting selection. `v4`
 * marks changes made on /workstreams, like its other events.
 */
export function logWorkstreamMetricsTimeframeChanged(
  source: WorkstreamMetricsViewSource,
  data: {
    change_type: 'grain' | 'timeframe';
    grain: 'annual' | 'quarterly';
    quarter?: string;
    year: number;
    workstream_id?: number;
    v4?: true;
  }
) {
  analyticsLogger().logEvent('WORKSTREAM_METRICS_TIMEFRAME_CHANGED', {
    source,
    ...data,
  });
}
